export default "__VITE_ASSET__15c8953b__"